fragment AccessFragment on Access_Level {
  tier
	kyc
	kyc_retry_count
	withdrawal_blocked
	withdrawal_block_reason
	withdrawal_unblock_date
}
